// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown--GKl4p","menu-item":"menu-item--1Kxjw"};